export const hasTextSelection = () => {
  if (typeof window === "undefined") return false;
  const selection = window.getSelection();
  return !!selection && selection.toString().length !== 0;
};
